import React from 'react'
import WTextField from './STextField'
import WCurrencyField from './SCurrencyField'
import WDateField from './SDateField'
import WDateTimeField from './SDateTimeField'
import WMemoField from './SMemoField'
import WNumericField from './SNumericField'
import WPhoneField from './SPhoneField'
import WSignatureField from './SSignatureField'
import WURLField from './SURLField'
import WYesNoField from './SYesNoField'
import WAPUserField from './SAPUserField'
import WListField from './SListField'
import WMultipleListField from './SMultipleListField'
import WEntityListField from './SEntityListField'
import WMultipleEntityListField from './SMultipleEntityListField'
import SDateCalculationField from './SDateCalculationField'
import SDateCalculationActionField from './SDateCalculationActionField'
import SDateStampField from './SDateStampField'
import SDateTimeStampField from './SDateTimeStampField'
import SDisplayFieldValueField from './SDisplayFieldValueField'
import SDurationField from './SDurationField'
import SEmailField from './SEmailField'
import SFullAddressField from './SFullAddressField'
import SNumericAutoIncrementField from './SNumericAutoIncrementField'
import SNumericCalculationField from './SNumericCalculationField'
import SNumericFormulaField from './SNumericFormulaField'
import SStatusField from './SStatusField'
import STimeField from './STimeField'
import STimeZoneField from './STimeZoneField'
import STimeCalculationActionField from './STimeCalculationActionField'
import STimeDurationActionField from './STimeDurationActionField'
import SUserStampField from './SUserStampField'
import WSubGroupEntityListField from './SubGroupListField'

export default function StepActionFields({
  data,
  fieldType,
  entity_id,
  itemSelected,
  fieldId,
  tabActive,
  onChange = (e, key, value) => {},
}) {
  switch (fieldType) {
    case 'TextField':
      return <WTextField onChange={onChange} data={data} tabActive={tabActive} />
    case 'CurrencyField':
      return <WCurrencyField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateField':
      return <WDateField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateTimeField':
      return (
        <WDateTimeField
          onChange={onChange}
          data={data}
          itemSelected={itemSelected}
          tabActive={tabActive}
        />
      )
    case 'MemoField':
      return <WMemoField onChange={onChange} data={data} tabActive={tabActive} />
    case 'NumericField':
      return <WNumericField onChange={onChange} data={data} tabActive={tabActive} />
    case 'PhoneField':
      return <WPhoneField onChange={onChange} data={data} tabActive={tabActive} />
    case 'SignatureField':
      return <WSignatureField onChange={onChange} data={data} tabActive={tabActive} />
    case 'UrlField':
      return <WURLField onChange={onChange} data={data} tabActive={tabActive} />
    case 'YesNoField':
      return <WYesNoField onChange={onChange} data={data} tabActive={tabActive} />
    case 'ApUserField':
      return (
        <WAPUserField
          onChange={onChange}
          data={data}
          itemSelected={itemSelected}
          fieldType={fieldType}
          fieldId={fieldId}
          tabActive={tabActive}
        />
      )
    case 'ListField':
      return (
        <WListField
          onChange={onChange}
          data={data}
          itemSelected={itemSelected}
          tabActive={tabActive}
        />
      )
    case 'MultipleListField':
      return <WMultipleListField onChange={onChange} data={data} tabActive={tabActive} />
    case 'EntityListField':
      if (data?.is_parent_child_relation) {
        return (
          <WSubGroupEntityListField
            onChange={onChange}
            data={data}
            itemSelected={itemSelected}
            fieldType={fieldType}
            fieldId={fieldId}
            tabActive={tabActive}
          />
        )
      } else {
        return (
          <WEntityListField
            onChange={onChange}
            data={data}
            itemSelected={itemSelected}
            fieldType={fieldType}
            fieldId={fieldId}
            tabActive={tabActive}
          />
        )
      }

    case 'MultipleEntityListField':
      return <WMultipleEntityListField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateCalculationField':
      return <SDateCalculationField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateCalculationActionField':
      return <SDateCalculationActionField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateStampField':
      return <SDateStampField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateTimeStampField':
      return <SDateTimeStampField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DisplayValueField':
      return <SDisplayFieldValueField onChange={onChange} data={data} tabActive={tabActive} />
    case 'DateDurationField':
      return <SDurationField onChange={onChange} data={data} tabActive={tabActive} />
    case 'EmailField':
      return <SEmailField onChange={onChange} data={data} tabActive={tabActive} />
    case 'AddressField':
      return <SFullAddressField onChange={onChange} data={data} tabActive={tabActive} />
    case 'NumericAutoIncrementField':
      return <SNumericAutoIncrementField onChange={onChange} data={data} tabActive={tabActive} />
    case 'NumericCalculationField':
      return <SNumericCalculationField onChange={onChange} data={data} tabActive={tabActive} />
    case 'NumericFormulaField':
      return <SNumericFormulaField onChange={onChange} data={data} tabActive={tabActive} />
    case 'StatusField':
      return (
        <SStatusField onChange={onChange} data={data} entity_id={entity_id} tabActive={tabActive} />
      )
    case 'TimeField':
      return <STimeField onChange={onChange} data={data} tabActive={tabActive} />
    case 'TimeZoneField':
      return <STimeZoneField onChange={onChange} data={data} tabActive={tabActive} />
    case 'TimeCalculationActionField':
      return <STimeCalculationActionField onChange={onChange} data={data} tabActive={tabActive} />
    case 'TimeDurationActionField':
      return <STimeDurationActionField onChange={onChange} data={data} tabActive={tabActive} />
    case 'UserStampField':
      return <SUserStampField onChange={onChange} data={data} tabActive={tabActive} />
    default:
      return null
  }
}
